import React from "react";
import EmailSetting from "./EmailSetting/EmailSetting";
import EmailConfig from "./emailConfig/EmailConfig";
import { CanAccessThisPage } from "Common/RoleVerify";

const EmailSettings = () => {

    return (
        <CanAccessThisPage menu_access={["can_access", "can_edit"]}>
            <EmailSetting />
            <EmailConfig />
        </CanAccessThisPage>
    );
};

export default EmailSettings;